var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTanya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,84.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180 759 c0 -5 -4 -7 -10 -4 -7 4 -10 -73 -10 -224 0 -231 0 -231 23 -232 83 -4 254 -5 315 -1 l72 5 0 233 0 234 -195 0 c-131 0 -195 -3 -195 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646 750 c-12 -33 -1 -453 12 -458 9 -3 12 45 12 220 0 202 -8 282 -24 238z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 205 c35 -24 150 -31 173 -11 15 13 20 14 24 4 4 -8 6 -7 6 5 1 15 -11 17 -111 17 -101 0 -110 -1 -92 -15z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,84.000000) scale(0.100000,-0.100000)",
    fill: "#D6E4F5",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157 773 c-4 -3 -7 -114 -7 -245 0 -238 0 -238 28 -237 23 2 24 2 5 6 -23 4 -23 4 -23 234 0 151 3 228 10 224 6 -3 10 -1 10 4 0 8 64 11 195 11 l195 0 0 -234 c0 -235 0 -235 -47 -239 -48 -3 -48 -3 5 -5 52 -2 52 -2 52 243 l0 245 -208 0 c-115 0 -212 -3 -215 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 515 c0 -143 2 -200 3 -127 2 73 2 190 0 260 -1 70 -3 10 -3 -133z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 763 c-9 -9 -7 -205 2 -268 5 -29 6 11 3 91 -5 145 0 192 18 164 12 -18 13 -460 2 -460 -4 0 -14 6 -21 12 -10 11 -11 10 -6 -4 4 -10 16 -18 26 -18 18 0 19 11 19 233 0 240 -8 286 -43 250z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734 480 c0 -151 2 -213 3 -138 2 76 2 200 0 275 -1 76 -3 14 -3 -137z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 204 c-6 -34 0 -35 129 -32 109 3 109 3 112 31 3 27 3 27 -116 27 -120 0 -120 0 -125 -26z m232 -1 c0 -12 -2 -13 -6 -5 -4 10 -9 9 -24 -4 -23 -20 -138 -13 -173 11 -18 14 -9 15 92 15 100 0 112 -2 111 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 201 c0 -27 2 -30 23 -22 12 5 22 17 22 27 0 12 -8 20 -22 22 -20 3 -23 -1 -23 -27z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,84.000000) scale(0.100000,-0.100000)",
    fill: "#2F7ED2",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 520 c0 -151 2 -213 3 -138 2 76 2 200 0 276 -1 75 -3 13 -3 -138z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 783 c-3 -5 91 -7 209 -5 l214 3 0 -245 0 -245 -67 -4 c-68 -4 -68 -4 2 -3 l70 1 0 250 0 250 -212 3 c-116 1 -214 -1 -216 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682 508 c-1 -170 -5 -228 -14 -231 -10 -4 -10 -6 0 -6 21 -2 23 16 19 244 l-2 220 -3 -227z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 283 c37 -2 100 -2 140 0 40 1 10 3 -67 3 -77 0 -110 -1 -73 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 213 c2 -25 2 -25 6 -5 4 23 6 23 128 20 68 -2 121 0 118 5 -2 4 -60 7 -129 7 -124 0 -124 0 -123 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 232 c-43 -3 -43 -3 -43 -55 0 -52 0 -52 50 -53 50 0 50 0 50 52 0 60 0 60 -57 56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612 203 c1 -38 1 -38 5 -5 4 27 8 33 26 30 31 -4 34 -36 5 -48 -17 -7 -18 -9 -4 -7 49 6 40 67 -10 67 -21 0 -24 -4 -22 -37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278 123 c142 -4 142 -4 142 -33 0 -16 4 -31 8 -34 5 -3 6 12 3 32 -6 37 -6 37 -151 37 l-145 1 143 -3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,84.000000) scale(0.100000,-0.100000)",
    fill: "#0C254C",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 522 c0 -203 3 -281 12 -290 9 -9 9 -20 -1 -48 -18 -51 -13 -53 154 -56 150 -3 150 -3 153 -33 5 -45 17 -50 56 -26 36 23 36 23 66 1 38 -27 58 -21 62 22 3 28 8 33 37 39 76 16 76 16 79 329 2 238 1 284 -13 310 -16 30 -16 30 -310 30 l-295 0 0 -278z m475 13 l0 -250 -217 -3 -218 -2 0 248 c0 137 3 252 7 256 4 3 102 5 217 4 l211 -3 0 -250z m81 231 c18 -13 19 -30 22 -247 3 -240 1 -252 -36 -243 -22 6 -22 6 -22 255 0 137 4 249 8 249 5 0 17 -6 28 -14z m-244 -531 c2 -3 3 -18 0 -35 -4 -30 -4 -30 -128 -30 -124 0 -124 0 -124 35 0 35 0 35 123 35 68 0 126 -2 129 -5z m148 -59 c0 -52 0 -52 -50 -52 -50 1 -50 1 -50 53 0 52 0 52 43 55 57 4 57 4 57 -56z m101 48 c18 -21 0 -48 -35 -52 -24 -3 -26 0 -26 32 0 40 35 52 61 20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTanya);
export default __webpack_public_path__ + "static/media/tanya.8bfa1edbe7261e619deeba3205f262b3.svg";
export { ForwardRef as ReactComponent };